import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=7fecf8ee&scoped=true&"
import script from "./Referral.vue?vue&type=script&lang=js&"
export * from "./Referral.vue?vue&type=script&lang=js&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=7fecf8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fecf8ee",
  null
  
)

/* custom blocks */
import block0 from "./Referral.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./Referral.vue?vue&type=custom&index=1&blockType=i18n&lang=yaml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports